<template>
  <div class="my-user-item-container" :class="className">
    <div class="my-col">
      <simple-item-ts-card :ts="item.ts"></simple-item-ts-card>
      <div class="my-div">
        <b>{{ item.eventText }}</b>
      </div>
      <div class="my-grow"></div>
    </div>
  </div>
</template>

<script>
import SimpleItemTsCard from "../common/SimpleItemTSCard.vue";

export default {
  name: "cmd-card",
  components: { SimpleItemTsCard },
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  watch: {},
  computed: {
    className() {
      if (this.hasError) return "error-box";
      if (this.hasWarning) return "warning-box";
      return "";
    },
    hasError() {
      return this.item && this.item.type == "critical";
    },
    hasWarning() {
      return this.item && this.item.type == "warning";
    },
  },
};
</script>

<style lang="css" scoped>
.my-user-item-container {
  margin-top: 0px;
  margin-bottom: 2px;
  border: solid 1px green;
  border-radius: 3px;
  padding: 5px;
}

.my-col {
  display: flex;
  flex-direction: column;
}

.my-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

.my-div {
  margin-right: 20px;
}

.my-grow {
  flex-grow: 1;
}

.my-button {
  margin: 0px;
  padding: 0px;
  height: 24px;
}

.error-box {
  background-color: #ffe0e0;
  border-color: #ff0000;
}

.warning-box {
  border: 1px solid #c48f00;
  background-color: #fff4cc;
}
</style>
